import { NgModule } from '@angular/core';
import { MenuModule } from '../menu/menu.module';
import { SearchTemporaryDOAComponent } from '../search/temporary-doa/searchtemporarydoa.component';
import { SearchPermanentDOAComponent } from '../search/permanent-doa/searchpermanentdoa.component';
import { SharedModule } from '../shared.module';
import { MaterialModule } from '../material.module';

const componentList = [
  SearchPermanentDOAComponent,
  SearchTemporaryDOAComponent,
];

@NgModule({
  imports: [MenuModule, SharedModule, MaterialModule],
  declarations: [componentList],
})
export class SearchModule {}
